/**
 * separadores.ts — Categoria "Separadores" (10 modelos premium)
 *
 * Espaços, linhas e faixas para dar respiro entre as seções da página.
 *
 * RELEASE: v1.0.0 - 2026-09-10 - 10 modelos novos (Studio, motor de modelos — Lote C)
 */

import { registerPatterns } from './patternRegistry';
import type { StudioPatternDefinition } from './types';
import { WEB, b } from './_shared';

const modelos: StudioPatternDefinition[] = [
  {
    key: 'separador.espaco-pequeno',
    category: 'separadores',
    label: 'Espaço pequeno',
    description: 'Respiro curto entre dois blocos.',
    preview: 'divider',
    outputs: WEB,
    order: 1,
    build: () => [b('layout.spacer', { height: '24px' })],
  },
  {
    key: 'separador.espaco-medio',
    category: 'separadores',
    label: 'Espaço médio',
    description: 'Respiro padrão entre seções.',
    preview: 'divider',
    outputs: WEB,
    order: 2,
    build: () => [b('layout.spacer', { height: '48px' })],
  },
  {
    key: 'separador.espaco-grande',
    category: 'separadores',
    label: 'Espaço grande',
    description: 'Respiro amplo para separar assuntos diferentes.',
    preview: 'divider',
    outputs: WEB,
    order: 3,
    build: () => [b('layout.spacer', { height: '96px' })],
  },
  {
    key: 'separador.linha',
    category: 'separadores',
    label: 'Linha divisória',
    description: 'Linha fina em cinza claro.',
    preview: 'divider',
    outputs: WEB,
    order: 4,
    build: () => [b('layout.divider', { color: '#e5e7eb', thickness: '1px' })],
  },
  {
    key: 'separador.linha-forte',
    category: 'separadores',
    label: 'Linha marcada',
    description: 'Linha mais grossa, para divisões evidentes.',
    preview: 'divider',
    outputs: WEB,
    order: 5,
    build: () => [b('layout.divider', { color: '#cbd5e1', thickness: '2px' })],
  },
  {
    key: 'separador.linha-com-espaco',
    category: 'separadores',
    label: 'Linha com respiro',
    description: 'Espaço, linha e espaço, tudo de uma vez.',
    preview: 'divider',
    outputs: WEB,
    order: 6,
    build: () => [
      b('layout.spacer', { height: '32px' }),
      b('layout.divider', { color: '#e5e7eb', thickness: '1px' }),
      b('layout.spacer', { height: '32px' }),
    ],
  },
  {
    key: 'separador.faixa-clara',
    category: 'separadores',
    label: 'Faixa clara',
    description: 'Faixa em cinza claro para mudar o ritmo da página.',
    preview: 'divider',
    outputs: WEB,
    order: 7,
    build: () => [b('section.layered', { paddingY: 'md', align: 'center', maxWidth: '1280px', backgroundColor: '#f8fafc' }, [])],
  },
  {
    key: 'separador.faixa-escura',
    category: 'separadores',
    label: 'Faixa escura',
    description: 'Faixa escura fina, boa antes do rodapé.',
    preview: 'divider',
    outputs: WEB,
    order: 8,
    build: () => [b('section.layered', { paddingY: 'sm', align: 'center', maxWidth: '1280px', backgroundColor: '#0f172a' }, [])],
  },
  {
    key: 'separador.com-selo',
    category: 'separadores',
    label: 'Divisor com selo',
    description: 'Linha com um selo curto no centro.',
    preview: 'divider',
    outputs: WEB,
    order: 9,
    build: () => [
      b('section.layered', { paddingY: 'sm', align: 'center', maxWidth: '900px' }, [
        b('ui.badge', { text: 'Continua', variant: 'outline', align: 'center' }),
      ]),
      b('layout.divider', { color: '#e5e7eb', thickness: '1px' }),
    ],
  },
  {
    key: 'separador.gradiente',
    category: 'separadores',
    label: 'Faixa com degradê',
    description: 'Transição suave entre duas seções.',
    preview: 'divider',
    outputs: WEB,
    order: 10,
    build: () => [b('section.layered', { paddingY: 'md', align: 'center', maxWidth: '1280px', backgroundGradient: 'soft' }, [])],
  },
];

registerPatterns(modelos);
